import { DictionaryValuesService } from './../services/dictionaryValues.service';
import { DictionaryValue } from './../models/classes/dictionary/dictionaryValue';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";


@Injectable()
export class LotsResolver {
  constructor(
    private dictionaryValueSrv: DictionaryValuesService,
    private uiSrv: UiService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DictionaryValue[]> {
    this.uiSrv.routeLoadingStateChanged.next(true);

    return this.dictionaryValueSrv.getLotsList()
      .pipe(
        tap(() => {
          this.uiSrv.routeLoadingStateChanged.next(false);
        })
      );
  }
}
